<template>
  <div>
    <el-dropdown @command="switchLanguage" v-if="isLogin">
      <span class="language">
        {{ curLang }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh_CN">简体中文</el-dropdown-item>
        <el-dropdown-item command="zh_HK">繁体中文</el-dropdown-item>
        <!--        <el-dropdown-item command="en">English</el-dropdown-item>-->
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown v-if="!isLogin">
      <div class="user">
        <i class="el-icon-user-solid"></i>
        {{ userName }}
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="logout">{{ $t('logout') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'UserTop',
  mounted() {
    this.userName = localStorage.getItem('userName')
    console.log('当前语言', this.$store.getters.language)
    this.handleLanguage(this.$store.getters.language)
  },
  props: {
    isLogin: Boolean
  },
  data: function () {
    return {
      userName: ''
    }
  },
  computed: {
    curLang() {
      let curLang = this.$store.getters.language
      let result = ''
      switch (curLang) {
        case 'zh_CN':
          result = '简体中文'
          break
        case 'zh_HK':
          result = '繁體中文'
          break
        case 'en':
          result = 'English'
          break
      }
      return result
    }
  },
  methods: {
    switchLanguage(lang) {
      this.handleLanguage(lang)
      location.reload()
    },
    handleLanguage(lang) {
      console.log('当前选中语言为', lang)
      this.$store.commit('setLanguage', lang)
      let result = ''
      switch (lang) {
        case 'zh_CN':
          result = 'zn'
          break
        case 'zh_HK':
          result = 'hk'
          break
        case 'en':
          result = 'en'
          break
      }
      this.chooesLange(result)
    },
    chooesLange(languageItem) {
      this.$i18n.locale = languageItem
    },
    logout() {
      this.$store.commit('setToken', '')
      this.$store.commit('setAccount', '')
      localStorage.setItem('userName', '')
      localStorage.setItem('account', '')
      Cookies.set('retailogMenuTitle', '')
      localStorage.setItem('surveyMenuData', '')
      localStorage.cellphone = ''
      // this.$router.push('/login')
      window.location.replace("https://uat.lingshutong.cn/#/login")
    }
  }
}
</script>

<style scoped lang="sass">
.user
  margin: 0 20px 0 30px
  font-size: 14px
  color: #444

.language
  margin: 0 0 0 30px
</style>



// WEBPACK FOOTER //
// src/topdoor/components/UserTop.vue